import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { OperatorSettings } from '../../../models/operator-settings.model';
import { CurrencyUpdatePayload } from '../../../models/currency.model';
import { OperatorSettingsCurrencyActions } from '../currency/currency.actions';
import { OperatorSettingsActions } from '../actions/operator-settings.actions';

@Injectable({ providedIn: 'root' })
export class OperatorSettingsActionsFacade {
  private readonly _store = inject(Store);

  public load(): void {
    this._store.dispatch(OperatorSettingsActions.load());
  }

  public update(id: number, data: Partial<OperatorSettings>): void {
    this._store.dispatch(OperatorSettingsActions.update({ id, data }));
  }

  public uploadPSIDs(formData: FormData): void {
    this._store.dispatch(OperatorSettingsActions.uploadPSIDs({ formData }));
  }

  public uploadUnicornQuotas(file: File): void {
    this._store.dispatch(OperatorSettingsActions.uploadUnicornQuotas({ file }));
  }

  public downloadUnicornMappings(): void {
    this._store.dispatch(OperatorSettingsActions.downloadUnicornMappings());
  }

  public downloadUnicornTemplate(): void {
    this._store.dispatch(OperatorSettingsActions.downloadUnicornTemplate());
  }

  public uploadCrmIdFile(file: File): void {
    this._store.dispatch(OperatorSettingsActions.uploadCrmId({ file }));
  }

  public downloadCrmIdTemplate(): void {
    this._store.dispatch(OperatorSettingsActions.downloadCrmIdTemplate());
  }

  public loadCurrencies(): void {
    this._store.dispatch(OperatorSettingsCurrencyActions.loadCurrencies());
  }

  public updateCurrency(
    currencyShortCode: string,
    data: CurrencyUpdatePayload,
  ): void {
    this._store.dispatch(
      OperatorSettingsCurrencyActions.updateCurrency({
        currencyShortCode,
        data,
      }),
    );
  }

  public uploadTrafficDensityFile(
    file: File,
    country: string,
    countryName: string,
  ): void {
    this._store.dispatch(
      OperatorSettingsActions.uploadTrafficDensityFile({
        file,
        country,
        countryName,
      }),
    );
  }

  public downloadTrafficDensityTemplate(): void {
    this._store.dispatch(
      OperatorSettingsActions.downloadTrafficDensityTemplate(),
    );
  }

  public downloadTrafficDensityCurrentFile(country: string): void {
    this._store.dispatch(
      OperatorSettingsActions.downloadTrafficDensityCurrentFile({ country }),
    );
  }
}
